import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import PublicLayout from "@/components/PublicLayout";
import SEOHead from "@/components/SEOHead";
import { api } from "@/lib/api";

export default function StaticPage() {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    api.get(`/pages/${slug}`).then((r) => setPage(r.data.page)).catch(() => setNotFound(true));
  }, [slug]);

  if (notFound) {
    return (
      <PublicLayout>
        <div className="max-w-3xl mx-auto py-24 text-center px-4">
          <h1 className="font-display font-bold text-3xl">Page not found</h1>
          <Link to="/" className="text-[#1E3A8A] mt-4 inline-block">← Back home</Link>
        </div>
      </PublicLayout>
    );
  }
  if (!page) return <PublicLayout><div className="p-10 text-slate-500">Loading…</div></PublicLayout>;

  return (
    <PublicLayout>
      <SEOHead title={page.seo_title || page.title} description={page.seo_description} />
      <article className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <h1 className="font-display font-bold text-4xl text-[#0A192F] leading-tight" data-testid="page-title">{page.title}</h1>
        <div
          className="prose prose-slate max-w-none mt-6 text-slate-700 leading-relaxed"
          dangerouslySetInnerHTML={{ __html: page.body_html || "" }}
        />
      </article>
    </PublicLayout>
  );
}
